import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getIssuer = (state) => resolveProp('identity.config.issuer', state);
const getIdToken = (state) => resolveProp('identity.session.idToken', state);
const getLogoutRedirectUri = (state) => resolveProp('identity.config.logoutRedirectUri', state);

export default createSelector(getIssuer, getIdToken, getLogoutRedirectUri, (issuer, idToken, logoutRedirectUri) => {
    if (issuer && idToken) {
        return `${issuer}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${encodeURIComponent(
            logoutRedirectUri,
        )}`;
    }
    return null;
});
